<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Référence</label>
          <input type="text" class="form-control" formControlName="reference" placeholder="Référence">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Type de pénalité <span class="text-danger">*</span></label>
          <select class="form-control" formControlName="typePenalite">
            <option *ngFor="let t of typesPenalite" [value]="t.value">{{ t.label }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Montant impayé de base <span class="text-danger">*</span></label>
          <input type="number" class="form-control" formControlName="montantImpayeBase">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Taux appliqué (%)</label>
          <input type="number" class="form-control" formControlName="tauxApplique" step="0.01">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Jours de retard</label>
          <input type="number" class="form-control" formControlName="joursRetard">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Montant pénalité</label>
          <input type="number" class="form-control" formControlName="montantPenalite">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Montant payé</label>
          <input type="number" class="form-control" formControlName="montantPaye">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Statut</label>
          <select class="form-control" formControlName="statut">
            <option *ngFor="let s of statuts" [value]="s.value">{{ s.label }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Date de calcul</label>
          <input type="date" class="form-control" formControlName="dateCalcul">
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Description</label>
          <textarea class="form-control" formControlName="description" rows="2"></textarea>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onClose()">Fermer</button>
  <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="onSubmit()">Enregistrer</button>
</div>
